import React from "react";

const Faq = () => {
  return (
    <div className="flex flex-col lg:flex-row justify-center">
      <div className=" text-white py-32">
        <div className="py-4 max-w-3xl mx-auto bg-slate-900 p-8 rounded-lg shadow-lg">
          <h1 className="text-3xl font-bold mb-4">
            Frequently Asked Questions
          </h1>
          <h3 className="text-xl"> Upcoming</h3>
          <p className="mb-8">F.A.Q. to be added soon</p>
        </div>
      </div>
    </div>
  );
};

export default Faq;
